import { MutationTree } from 'vuex';
import { TemplateItem, TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setTemplates:(state, data) => {
        state.templates = data
    },
    setMultichannelTemplates:(state, data) => {
        state.multichannelTemplates = data
    },
    setTemplateItem:(state, data) => {
        state.templateItem = data
    },
    addTemplates(state, templates: TemplateItem[]) {
        const idList: number[] = state.allTemplates.map((t: TemplateItem) => t.templateId!);
        templates.forEach((t: TemplateItem) => {
            if (!idList.includes(t.templateId!)) {
                state.allTemplates.push(t);
            }
        });
    },
    setDistributions:(state, data) => {
        state.distributions = data
    },
    pushDistributions:(state, data) => {
        state.distributions = state.distributions.concat(data)
    },
    setTemplateObject:(state, data) => {
        state.templateObject = data
    }
};